import { Experiment, QuestEditorApi } from "@worldwidewebb/client-quests";
import { axiosInstance, buildQuestClientBasePath } from "..";

const questEditorApi = new QuestEditorApi(undefined, buildQuestClientBasePath(), axiosInstance);

export async function getExperiments(): Promise<Experiment[]> {
  try {
    const { data: experiments } = await questEditorApi.getExperiments();

    if (!experiments) {
      return [];
    }

    return experiments.sort((a, b) => a.experimentId.localeCompare(b.experimentId));
  } catch (error) {
    console.error(error);
    throw error;
  }
}
